import React from 'react';
import { Badge } from 'react-bootstrap';

import TimbradoSftpStatus from '../../enum/TimbradoSftpStatus';

const TimbradoSftpStatusBadge = ({ data }) => {
  let variant = 'light';

  const status = TimbradoSftpStatus.search(data.status) || TimbradoSftpStatus.undefined();

  if (status.isSuccess()) {
    variant = 'success';
  } else if (status.isFailed() || status.isError()) {
    variant = 'danger';
  } else if (status.isQueued()) {
    variant = 'warning';
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

export default TimbradoSftpStatusBadge;
